import { ComboboxEditor, DataGrid, EntityDialog, HtmlContentEditor, PasswordEditor, getjQuery } from "@serenity-is/corelib";
import { TranslationConfig, Config, ErrorHandling, Culture } from "@serenity-is/corelib";
//import { siteLanguageList } from "./Helpers/LanguageList";
import { getLanguageList } from "./Helpers/LanguageList";
import { Grid, gridDefaults } from "@serenity-is/sleekgrid";
import { UserPreferenceStorage } from "@serenity-is/extensions";

Config.rootNamespaces.push('UpgearCRM');
//EntityDialog.defaultLanguageList = siteLanguageList[0];
TranslationConfig.getLanguageList = getLanguageList;
//HtmlContentEditor.CKEditorBasePath = "~/Serenity.Assets/Scripts/ckeditor/";  //Removed for update suggestion
gridDefaults.useCssVars = false;
gridDefaults.enableHtmlRendering = true

let $ = getjQuery();
if ($?.fn?.['colorbox']) {
    $.fn['colorbox'].settings.maxWidth = "95%";
    $.fn['colorbox'].settings.maxHeight = "95%";
}

window.onerror = ErrorHandling.runtimeErrorHandler;
window.addEventListener('unhandledrejection', ErrorHandling.unhandledRejectionHandler);

DataGrid.defaultPersistenceStorage = new UserPreferenceStorage();

// =========================================================
// BROWSER PASSWORD AUTOFILL
// =========================================================
//
// A browser that saved the Upgear login fills it into any form with a password box: the
// password into the box, and the username into the text box just before it. On the User
// dialog that box is the Companies picker's input (a combobox keeps its value in a text
// input the picker hides), so saving a user posted Companies: ["admin"] and failed with
// "The JSON value could not be converted to System.Int32. Path: $[0]" (pepcopp, 12 Oct
// 2026). The same fill put the Upgear password into Email Settings' mailbox password.
// "new-password" tells the browser this box is for a new secret, never the saved one, and
// a picker's input is never a place for a login. The login page sets "current-password" on
// its own box (LoginPage.tsx), the one place the saved login should go.
const passwordElement = PasswordEditor.createDefaultElement;
PasswordEditor.createDefaultElement = function () {
    const el = passwordElement.call(this) as HTMLInputElement;
    el.setAttribute("autocomplete", "new-password");
    return el;
};

const comboboxElement = ComboboxEditor.createDefaultElement;
ComboboxEditor.createDefaultElement = function () {
    const el = comboboxElement.call(this) as HTMLInputElement;
    el.setAttribute("autocomplete", "off");
    return el;
};

// =========================================================
// CULTURE / DATE FORMAT
// =========================================================
//
// The server emits the current request's culture into
// <script id="ScriptCulture"> in _LayoutHead.cshtml; Serenity reads it
// and populates the Culture object before this script runs. That value
// is driven by:
//   1) Startup.cs RequestLocalizationOptions sets every supported
//      culture's ShortDatePattern to "dd-MM-yyyy" (the legacy Indian
//      default). Tenants who haven't touched Company.DateFormatOverride
//      still get exactly this.
//   2) CompanyCultureMiddleware (Phase 2 — wired AFTER UseAuthentication
//      in Startup.cs) clones CurrentCulture per request and applies
//      the operator's company override. ScriptCulture then emits the
//      cloned format, so the JS Culture picks it up automatically.
//
// We DO NOT hardcode dateFormat here anymore — that override would
// stomp on the per-tenant value the server already populated. We only
// fall back to "dd-MM-yyyy" if ScriptCulture didn't emit anything
// (defensive — shouldn't happen, but keeps Indian default safe if the
// pipeline ever fails).
if (!Culture.dateFormat) {
    Culture.dateFormat = "dd-MM-yyyy";
    Culture.dateSeparator = "-";
    Culture.dateOrder = "dmy";
}